import { take, select } from 'redux-saga/effects';
import { RETRIEVED_FACEPLATE_GROUPS, RETRIEVED_BRAND_CONFIG } from 'capi/redux';
import { getBrandCatalogs } from '../brand/brandSelectors';
import { getFaceplateGroups } from '../landingPage/landingPageSelectors';
export default function* productDependencySaga() {
    
    const catalogs = yield select(getBrandCatalogs);
    if (catalogs.size === 0) {
        yield take(RETRIEVED_BRAND_CONFIG.CATALOG);
    }
    const faceplates = yield select(getFaceplateGroups);
    if (faceplates.size === 0) {
        yield take(RETRIEVED_FACEPLATE_GROUPS);
    }
}
